import React from "react";
import GameContainer from "../../../../../edu_lms/components/Game";
import WordSearchContainer from "../../../../../edu_lms/components/Game/WordSearch/WordSearchContainer";

const WordSearch = ({ activity, bookId, showResult }) => {
	return (
		<GameContainer data={activity}>
			<WordSearchContainer data={activity} objectId={bookId} showResult={showResult}/>
		</GameContainer>
	);
};

export default WordSearch;
